import { render, staticRenderFns } from "./DashedButtons.vue?vue&type=template&id=53b36d12&scoped=true&"
import script from "./DashedButtons.vue?vue&type=script&lang=js&"
export * from "./DashedButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b36d12",
  null
  
)

export default component.exports